import {
  TagsInputProps as MantineTagsInputProps,
  TagsInput as MantineTagsInput,
} from '@mantine/core';

export type TagsInputProps = MantineTagsInputProps;

export const TagsInput = MantineTagsInput;

TagsInput.displayName = 'TagsInput';
